// @flow
import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { connect } from 'react-redux';

import api from '../../../lib/api';
import endpoints from '../../../lib/endpoints';
import Toggler from '../../../components/UI/Toggler';

import { masqueradeAsUser } from '../../../redux/actions/authActions';

type User = {
  id: string,
  roles: Array<string>,
  email: string,
  fullname: string,
  index: number,
};

type Props = {
  user: User,
  updateUser: Function,
  masqueradeAsUser: (id: string) => void,
};

type ChangeUserRoleParams = {
  userId: string,
  role: string,
  operation: 'add' | 'remove',
};

class ActionsDropdown extends Component<Props> {
  render() {
    const { masqueradeAsUser, user } = this.props;
    const { roles, id } = user;

    const isLeader = this.checkIfUserHasRole(roles, 'leader');
    const isLodgeOwner = this.checkIfUserHasRole(roles, 'lodge_owner');

    return (
      <Toggler>
        {({ on, toggle }) => (
          <Dropdown isOpen={on} toggle={toggle}>
            <DropdownToggle caret>Edit</DropdownToggle>
            <DropdownMenu>
              <DropdownItem onClick={() => this.handleUserRole('leader')}>
                {isLeader ? 'Remove Role - Leader' : 'Add Role - Leader'}
              </DropdownItem>
              <DropdownItem onClick={() => this.handleUserRole('lodge_owner')}>
                {isLodgeOwner ? 'Remove Role - Lodge Owner' : 'Add Role - Lodge Owner'}
              </DropdownItem>
              <DropdownItem divider />
              <DropdownItem>Disable Account</DropdownItem>
              <DropdownItem divider />
              <DropdownItem onClick={() => masqueradeAsUser(id)}>
                Masquerade User
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        )}
      </Toggler>
    );
  }

  handleUserRole = async (roleToHandle: string) => {
    const { updateUser, user } = this.props;
    const { id, roles } = user;
    let updateUserInfo;

    // IF ROLE INCLUDES 'roleToHandle' REMOVE IT ELSE ADD IT
    if (this.checkIfUserHasRole(roles, roleToHandle)) {
      updateUserInfo = await this.changeUserRole({
        userId: id,
        role: roleToHandle,
        operation: 'remove',
      });
    } else {
      updateUserInfo = await this.changeUserRole({
        userId: id,
        role: roleToHandle,
        operation: 'add',
      });
    }

    // ON SUCCESSFULL API CALL UPDATE STATE
    if (updateUserInfo) {
      updateUser(updateUserInfo);
    }
  };

  changeUserRole = async ({ userId, role, operation }: ChangeUserRoleParams) => {
    let updateUserInfo;

    try {
      if (operation === 'add') {
        const { data } = await api.put(endpoints.admin.modifyRole(userId), {
          role,
        });
        updateUserInfo = data;
      } else if (operation === 'remove') {
        const { data } = await api.delete(endpoints.admin.modifyRole(userId), {
          role,
        });
        updateUserInfo = data;
      }
    } catch (e) {
      return null;
    }

    return updateUserInfo;
  };

  checkIfUserHasRole = (roles: Array<string>, roleToCheck: string) => {
    return Array.isArray(roles) && roles.join(' ').includes(roleToCheck);
  };
}

export default connect(
  null,
  { masqueradeAsUser }
)(ActionsDropdown);



// WEBPACK FOOTER //
// ./src/screens/Admin/UsersPanel/ActionsDropdown.jsx